import type { IBookingService, ICompany, IFile, IService } from '@types'
import { getLogoFile, getPhotos } from '@utils/company'
import { getBookingConfig } from './devEnvironment'

function getConfig() {
  const nuxtApp = tryUseNuxtApp()
  if (nuxtApp?.$config) {
    return getBookingConfig()
  }

  return {
    public: {
      S3_URL: process.env.NUXT_PUBLIC_S3_URL || '',
    },
  }
}

export function getImageUrl(path?: string) {
  return path ? `${getConfig().public.S3_URL}/qbp_photos/${path}` : ''
}

export function getServiceImages(service: IService) {
  return service.files?.map(f => getImageUrl(f.fullPath)) || []
}

export function getBookingServiceImage(service: Pick<IBookingService, 'files'>) {
  return service.files?.[0]?.url
}

export function getCompanyImages(company: ICompany) {
  return (company.addresses || [])
    .reduce<IFile[]>((res, a) => {
      res.push(...a.files)
      return res
    }, getPhotos(company))
    .map(f => getImageUrl(f.fullPath))
}

export function getLogoUrl(company: ICompany) {
  return getImageUrl(getLogoFile(company)?.fullPath)
}
